import Ajax from '../common/ajax'

export default {
  model: 'statistics',
  getPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/pageAgent`, queryParam)
  },
  getPageAdmin (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/pageTeacher`, queryParam)
  },
  getMonitor (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeEvaluation/v1/${this.model}/pageTeacherMonitor`, queryParam)
  }
}
